// extracted by mini-css-extract-plugin
export default {"faqContent":"FAQ_faqContent__BEilz","closeIcon":"FAQ_closeIcon__dc1hH","faqItem":"FAQ_faqItem__-X5cW","expandIcon":"FAQ_expandIcon__RhUsp","open":"FAQ_open__AD3LL"};